<template lang="pug">
div.filterTree__header--link-text.bkgNeutro(:class="headerClass")
  a(:href="redirectToNewSearchPath()").itemLink
    span.pr-1
      i.fa.fa-1x.fa-home.mr-1
      | {{ t("components.forms.filter_tree.home") }}
  div.resize_sidebar.d-flex
    button.btn(
      id="hidePanelButton"
      @click="collapsePanel"
    )
      i.fas.fa-angle-double-left
      | {{ t("components.forms.filter_tree.hide") }}
</template>
<script>
import mixins from "common/mixins"
import { mapMutations } from "vuex";

export default {
  name: 'forms-filters-tree-header-vue',
  props: {
    headerClass: { type: String, default: () => '' }
  },
  mixins: [mixins.translate],
  methods: {
    collapsePanel() {
      this.setCollapsePanel(true)
      this.$emit("update:panel_collapsed")
    },
    redirectToNewSearchPath(){
      if(gon.materia) {
        return gon.url_for.materias_hubs_path.replace('materia_id', gon.materia.id)
      }
      return gon.url_for.new_search_path.replace(':search_type', 'formularios')
    },
    ...mapMutations('hub_search', ['setCollapsePanel'])
  },
}

</script>